import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-143d6884"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "my_email_box"
}
const _hoisted_2 = {
  key: 1,
  class: "my_email_box"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" submit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PhoneEmail = _resolveComponent("PhoneEmail")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, {
      title: "Settings",
      backgroundColor: "#000",
      fontColor: "#fff"
    }),
    ($setup.isEmail && $setup.emailName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Email: " + _toDisplayString($setup.emailName), 1))
      : _createCommentVNode("", true),
    (!$setup.isEmail && $setup.my_phone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Phone: " + _toDisplayString($setup.my_phone), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_PhoneEmail, {
      isEmail: $setup.isEmail,
      ref: "passData",
      Toast: $setup.Toast
    }, null, 8, ["isEmail", "Toast"]),
    _createVNode(_component_van_button, {
      round: "",
      type: "primary",
      class: "van_buttons",
      color: "#f76900",
      onClick: $setup.submitFn
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}